// Bilingual content (ES / EN) for the FERINFECTED CORP landing page.

export const BRANDS = {
  celulares: [
    "iPhone 15 Pro Max",
    "Samsung Galaxy S24 Ultra",
    "Google Pixel 8 Pro",
    "Xiaomi 14",
    "Motorola Edge 50",
  ],
  consolas: [
    "PlayStation 5 Slim",
    "Xbox Series X",
    "Nintendo Switch OLED",
    "Steam Deck OLED",
    "Meta Quest 3",
  ],
  laptops: [
    "MacBook Pro M3",
    "Dell XPS 15",
    "Lenovo ThinkPad X1",
    "ASUS ROG Zephyrus",
    "HP Spectre x360",
  ],
  tvs: [
    "LG OLED evo G4",
    "Samsung Neo QLED 8K",
    "Sony BRAVIA XR A95L",
    "TCL QM8 QLED",
    "Hisense U8",
  ],
};

export const PARTNERS = [
  "Apple",
  "Samsung",
  "Sony",
  "LG",
  "Microsoft",
  "Nintendo",
  "Lenovo",
  "Dell",
  "HP",
  "ASUS",
  "Xiaomi",
  "TCL",
];

export const translations = {
  es: {
    nav: {
      inicio: "Inicio",
      servicios: "Servicios",
      productos: "Productos",
      nosotros: "Nosotros",
      aliados: "Aliados",
      contacto: "Contacto",
      cotizar: "Cotizar",
    },
    hero: {
      badge: "FERINFECTED CORP · S.A.P.I. de C.V.",
      l1: "DISTRIBUCIÓN",
      l2: "DE ELECTRÓNICA",
      l3: "SIN FRONTERAS",
      subtitle:
        "Comercialización, importación/exportación y logística de última milla para celulares, consolas, laptops y Smart TVs. Movemos tecnología a escala, con precisión operativa.",
      ctaServicios: "Explorar Servicios",
      ctaContacto: "Solicitar Cotización",
      scroll: "Scroll ↓",
      ticker: "Import · Export · Última Milla · Consultoría",
    },
    marquee: [
      "IMPORTACIÓN",
      "EXPORTACIÓN",
      "LOGÍSTICA",
      "ALMACENAMIENTO",
      "CONSULTORÍA",
      "INTERMEDIACIÓN",
    ],
    servicios: {
      overline: "Qué Hacemos",
      title: "Un ecosistema completo de distribución.",
      subtitle:
        "Integramos cada eslabón de la cadena — del origen al consumidor — bajo una sola operación coordinada.",
      serviceLabel: "Servicio",
      more: "Ver más",
      cards: [
        {
          title: "Importación & Exportación",
          desc: "Gestión aduanal, cumplimiento normativo y rutas internacionales optimizadas para mover electrónica entre mercados sin fricción.",
        },
        {
          title: "Logística de Última Milla",
          desc: "Entregas rápidas y trazables hasta el punto final, con visibilidad en tiempo real.",
        },
        {
          title: "Almacenamiento & Inventarios",
          desc: "Centros de distribución seguros y gestión inteligente de stock en tiempo real.",
        },
        {
          title: "Consultoría Estratégica",
          desc: "Diseño de cadenas de suministro y estrategia comercial para escalar operaciones.",
        },
        {
          title: "Comercialización & Intermediación",
          desc: "Conectamos fabricantes, mayoristas y retail con precios competitivos y volumen garantizado.",
        },
      ],
    },
    productos: {
      overline: "Catálogo FLUX",
      title: "Tecnología que movemos.",
      modelsLabel: "Modelos destacados",
      items: {
        celulares: {
          label: "Celulares",
          tag: "Smartphones & Wearables",
          count: "+80 modelos",
          desc: "Flagships y gama media de las principales marcas, con garantía y volumen para retail y mayoreo.",
        },
        consolas: {
          label: "Consolas",
          tag: "Gaming & Accesorios",
          count: "Todas las plataformas",
          desc: "Consolas de última generación, controles y periféricos con disponibilidad constante.",
        },
        laptops: {
          label: "Laptops",
          tag: "Cómputo & Movilidad",
          count: "Consumo y empresa",
          desc: "Portátiles de rendimiento, ultrabooks y equipos corporativos listos para despliegue.",
        },
        tvs: {
          label: "Smart TVs",
          tag: "Pantallas & Video",
          count: 'Hasta 98"',
          desc: "Televisores 4K/8K y pantallas comerciales con logística especializada de gran formato.",
        },
      },
    },
    nosotros: {
      overline: "Nosotros",
      titleA: "Infraestructura que",
      titleB: "escala contigo.",
      p1a: "FERINFECTED CORP, S.A.P.I. de C.V. es un operador integral de electrónica de consumo. Conectamos fabricantes, distribuidores y retail mediante una plataforma logística propia — ",
      p1b: " — que garantiza trazabilidad, velocidad y cumplimiento en cada envío.",
      p2: "Del despacho aduanal a la última milla, operamos con estándares corporativos y precisión tecnológica.",
      stats: [
        "Rutas internacionales",
        "Unidades distribuidas",
        "Entregas a tiempo",
        "Operación continua",
      ],
    },
    aliados: {
      overline: "Clientes & Aliados",
      title: "Marcas que confían en nosotros.",
      subtitle:
        "Trabajamos con los fabricantes y distribuidores líderes de la industria.",
      testimonials: [
        {
          quote:
            "FERINFECTED transformó nuestra cadena de importación. Tiempos de entrega 40% más rápidos y cero sorpresas en aduana.",
          name: "Laura Méndez",
          role: "Directora de Operaciones · TechMayorista",
        },
        {
          quote:
            "Su logística de última milla es impecable. Trazabilidad total en cada envío y un equipo que responde 24/7.",
          name: "Carlos Rivas",
          role: "Gerente de Compras · ElectroRetail MX",
        },
        {
          quote:
            "El mejor aliado para distribución de electrónica a escala en Latinoamérica. Volumen y precio, siempre cumplen.",
          name: "Ana Soto",
          role: "CEO · GadgetHub",
        },
      ],
    },
    contacto: {
      overline: "Contacto",
      title: "Hablemos de tu operación.",
      subtitle:
        "Cuéntanos qué necesitas mover y diseñaremos la ruta. Respuesta en menos de 24 horas hábiles.",
      location: "Cerrada Camino al Monte s/n, Santa Catarina Ayotzingo, 56623 Chalco, Estado de México",
      fields: {
        nombre: "Nombre *",
        email: "Correo *",
        empresa: "Empresa",
        mensaje: "Mensaje",
      },
      submit: "Enviar Solicitud",
      sending: "Enviando…",
      success: "¡Gracias! Tu solicitud fue enviada. Te contactaremos pronto.",
      errorRequired: "Completa tu nombre y correo para continuar.",
      errorSend: "No se pudo enviar. Intenta de nuevo en unos minutos.",
    },
    footer: {
      tagline:
        "Comercialización, distribución e intermediación de electrónica de consumo. Importación, exportación, logística y consultoría.",
      rights: "© 2026 FERINFECTED CORP, S.A.P.I. de C.V.",
      reserved: "Todos los derechos reservados",
    },
  },

  en: {
    nav: {
      inicio: "Home",
      servicios: "Services",
      productos: "Products",
      nosotros: "About",
      aliados: "Partners",
      contacto: "Contact",
      cotizar: "Get a Quote",
    },
    hero: {
      badge: "FERINFECTED CORP · S.A.P.I. de C.V.",
      l1: "ELECTRONICS",
      l2: "DISTRIBUTION",
      l3: "WITHOUT BORDERS",
      subtitle:
        "Commercialization, import/export and last-mile logistics for phones, consoles, laptops and Smart TVs. We move technology at scale, with operational precision.",
      ctaServicios: "Explore Services",
      ctaContacto: "Request a Quote",
      scroll: "Scroll ↓",
      ticker: "Import · Export · Last Mile · Consulting",
    },
    marquee: [
      "IMPORT",
      "EXPORT",
      "LOGISTICS",
      "WAREHOUSING",
      "CONSULTING",
      "BROKERAGE",
    ],
    servicios: {
      overline: "What We Do",
      title: "A complete distribution ecosystem.",
      subtitle:
        "We integrate every link of the chain — from origin to consumer — under one coordinated operation.",
      serviceLabel: "Service",
      more: "Learn more",
      cards: [
        {
          title: "Import & Export",
          desc: "Customs management, regulatory compliance and optimized international routes to move electronics across markets without friction.",
        },
        {
          title: "Last-Mile Logistics",
          desc: "Fast, traceable deliveries to the final destination, with real-time visibility.",
        },
        {
          title: "Warehousing & Inventory",
          desc: "Secure distribution centers and intelligent, real-time stock management.",
        },
        {
          title: "Strategic Consulting",
          desc: "Supply-chain design and commercial strategy to scale your operations.",
        },
        {
          title: "Commercialization & Brokerage",
          desc: "We connect manufacturers, wholesalers and retail with competitive pricing and guaranteed volume.",
        },
      ],
    },
    productos: {
      overline: "FLUX Catalog",
      title: "The technology we move.",
      modelsLabel: "Featured models",
      items: {
        celulares: {
          label: "Phones",
          tag: "Smartphones & Wearables",
          count: "+80 models",
          desc: "Flagships and mid-range from leading brands, with warranty and volume for retail and wholesale.",
        },
        consolas: {
          label: "Consoles",
          tag: "Gaming & Accessories",
          count: "All platforms",
          desc: "Latest-generation consoles, controllers and peripherals with constant availability.",
        },
        laptops: {
          label: "Laptops",
          tag: "Computing & Mobility",
          count: "Consumer & enterprise",
          desc: "Performance laptops, ultrabooks and corporate equipment ready for deployment.",
        },
        tvs: {
          label: "Smart TVs",
          tag: "Displays & Video",
          count: 'Up to 98"',
          desc: "4K/8K televisions and commercial displays with specialized large-format logistics.",
        },
      },
    },
    nosotros: {
      overline: "About",
      titleA: "Infrastructure that",
      titleB: "scales with you.",
      p1a: "FERINFECTED CORP, S.A.P.I. de C.V. is an end-to-end operator of consumer electronics. We connect manufacturers, distributors and retail through our own logistics platform — ",
      p1b: " — ensuring traceability, speed and compliance on every shipment.",
      p2: "From customs clearance to the last mile, we operate with corporate standards and technological precision.",
      stats: [
        "International routes",
        "Units distributed",
        "On-time deliveries",
        "Continuous operation",
      ],
    },
    aliados: {
      overline: "Clients & Partners",
      title: "Brands that trust us.",
      subtitle:
        "We work with the industry's leading manufacturers and distributors.",
      testimonials: [
        {
          quote:
            "FERINFECTED transformed our import chain. Delivery times 40% faster and zero surprises at customs.",
          name: "Laura Méndez",
          role: "Operations Director · TechMayorista",
        },
        {
          quote:
            "Their last-mile logistics is flawless. Full traceability on every shipment and a team that responds 24/7.",
          name: "Carlos Rivas",
          role: "Procurement Manager · ElectroRetail MX",
        },
        {
          quote:
            "The best partner for electronics distribution at scale in Latin America. Volume and price — they always deliver.",
          name: "Ana Soto",
          role: "CEO · GadgetHub",
        },
      ],
    },
    contacto: {
      overline: "Contact",
      title: "Let's talk about your operation.",
      subtitle:
        "Tell us what you need to move and we'll design the route. Reply within 24 business hours.",
      location: "Cerrada Camino al Monte s/n, Santa Catarina Ayotzingo, 56623 Chalco, State of Mexico",
      fields: {
        nombre: "Name *",
        email: "Email *",
        empresa: "Company",
        mensaje: "Message",
      },
      submit: "Send Request",
      sending: "Sending…",
      success: "Thank you! Your request was sent. We'll contact you soon.",
      errorRequired: "Please enter your name and email to continue.",
      errorSend: "Could not send. Please try again in a few minutes.",
    },
    footer: {
      tagline:
        "Commercialization, distribution and brokerage of consumer electronics. Import, export, logistics and consulting.",
      rights: "© 2026 FERINFECTED CORP, S.A.P.I. de C.V.",
      reserved: "All rights reserved",
    },
  },
};
